// Action Types
export const SET_KEYSTONE_TEAM_DETAILS_TABLE_BOSS_RANKINGS = 'SET_KEYSTONE_TEAM_DETAILS_TABLE_BOSS_RANKINGS';
export const SET_KEYSTONE_TEAM_DETAILS = 'SET_KEYSTONE_TEAM_DETAILS';
export const SET_TEAM_MYTHIC_PLUS_FILTERS = 'SET_TEAM_MYTHIC_PLUS_FILTERS';
export const SHOW_LOADING_SPINNER = 'SHOW_LOADING_SPINNER';
export const TOGGLE_OPEN_DUNGEON = 'TOGGLE_OPEN_DUNGEON';
export const SET_PENDING_SEASON = 'SET_PENDING_SEASON';

// Action Creator
const KeystoneTeamDetailsActionCreator = {
  setKeystoneTeamDetails(...args: any[]) {
    let details = null;
    let instanceId = 'default';
    if (args.length === 1) {
      details = args[0];
    } else {
      instanceId = args[0];
      details = args[1];
    }
    return {
      type: SET_KEYSTONE_TEAM_DETAILS,
      payload: {
        instanceId,
        details
      }
    };
  },

  setPendingSeason(season: any) {
    return {
      type: SET_PENDING_SEASON,
      payload: season
    };
  },

  setKeystoneTeamMythicPlusFilters(details: any) {
    return {
      type: SET_TEAM_MYTHIC_PLUS_FILTERS,
      payload: details
    };
  },

  showLoadingSpinner(show: boolean) {
    return {
      type: SHOW_LOADING_SPINNER,
      payload: show
    };
  },

  toggleOpenDungeon(dungeonId: number) {
    return {
      type: TOGGLE_OPEN_DUNGEON,
      payload: dungeonId
    };
  }
};

export default KeystoneTeamDetailsActionCreator;
